import { Dayjs } from 'dayjs'

export type DatePractitionerCell = {
    date: Dayjs
    practitionerId: number
}

export type DateLocationCell = {
    date: Dayjs
    locationId: number
}

export function isDatePractitionerCell(cell: DatePractitionerCell | DateLocationCell): cell is DatePractitionerCell {
    return 'practitionerId' in cell
}

export function isDateLocationCell(cell: DatePractitionerCell | DateLocationCell): cell is DateLocationCell {
    return 'locationId' in cell
}

export function arrayHasAtLeastOneElement<T>(array: T[]): array is [T, ...T[]] {
    return array.length > 0
}

/** Extracts the number part of a room code, e.g. `OP01` becomes `01`. */
export function getRoomNumber(roomCode: string): string {
    return /\d+$/.exec(roomCode)?.[0] ?? roomCode
}
